export default "/_next/static/images/Wire-5-1f945e324329fdff8b97f279d7a766f6.svg";